/*
 * ROBUST SELECTORS (no Foxify ID dependency)
 * The picker and buy button are found by STABLE Foxify CLASSES, not by the
 * volatile #x-... IDs that change every time the Foxify section is re-saved.
 * .x-variant-picker and .x-product-buy-button are stable Foxify classes, and
 * this file only loads on the Product Selector page, so there is exactly one
 * of each. This means a Foxify re-save can no longer break the bundle picker.
 */
(function() {
  'use strict';

  var PICKER_SELECTOR = '.x-variant-picker';
  var BUY_BUTTON_SELECTOR = '.x-product-buy-button';

  // Shared price map - built once, used by dropdowns + pricing engine
  var individualPrices = {};
  // Full selector variant lookup, keyed by "opt1|opt2|opt3" (Microbes+Feeder|Kelp|Compost).
  // Built from the embedded product.variants JSON, so the buy box adds the ONE
  // matching combination variant of the Product Selector (no dependency on the
  // individual products being published).
  var variantByOptions = {};

  var OPTION_BADGES = {
    'M+F 5L':  { text: 'BEST SELLER', type: 'seller' },
    'M+F 20L': { text: 'BEST VALUE',  type: 'value' }
  };

  var PRODUCT_LABELS = {
    'M+F': 'Soil Microbes + Microbe Feeder',
    'Kelp': 'Kelp Power',
    'Compost': 'Compost Microbes'
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildIndividualPrices() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var jsonScript = picker.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch(e) { return; }
    if (!variants || !variants.length) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
    var optionCount = fields.length;

    variants.forEach(function(v) {
      var opts = v.options;
      if (opts && opts.length) { variantByOptions[opts.join('|')] = v; }
      var skipCount = 0;
      var activeIndex = -1;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].indexOf('No ') === 0) { skipCount++; } else { activeIndex = i; }
      }
      if (skipCount === optionCount - 1 && activeIndex >= 0) {
        individualPrices[opts[activeIndex]] = v.price;
      }
    });

    fields.forEach(function(field) {
      var noOpts = field.querySelectorAll('.x-variant-picker__option[data-value^="No "]');
      noOpts.forEach(function(el) { individualPrices[el.dataset.value] = 0; });
    });
  }

  // Given the raw picker values (any order), slot them into
  // [Microbes+Feeder, Kelp, Compost] by prefix and return the matching
  // Product Selector combination variant (or null).
  function matchVariant(rawVals) {
    var opts = ['No M+F', 'No Kelp', 'No Compost'];
    (rawVals || []).forEach(function(val) {
      if (!val) return;
      if (val.indexOf('M+F') === 0 || val === 'No M+F') opts[0] = val;
      else if (val.indexOf('Kelp') === 0 || val === 'No Kelp') opts[1] = val;
      else if (val.indexOf('Compost') === 0 || val === 'No Compost') opts[2] = val;
    });
    return variantByOptions[opts.join('|')] || null;
  }

  function convertToDropdowns() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));

    // Product category names for each step
    var stepNames = ['Soil Microbes + Microbe Feeder', 'Kelp Power', 'Compost Microbes'];

    fields.forEach(function(field, fieldIndex) {
      var optionEls = Array.from(field.querySelectorAll('.x-variant-picker__option'));
      if (!optionEls.length) return;

      // Hide the radio button grid
      var optionValues = field.querySelector('.x-variant-picker__option-values');
      if (optionValues) optionValues.style.display = 'none';

      var categoryName = stepNames[fieldIndex] || 'Product';

      // Build the dropdown wrapper
      var wrapper = document.createElement('div');
      wrapper.className = 'soilife-dropdown-wrapper';

      var select = document.createElement('select');
      select.className = 'soilife-bundle-select';
      select.setAttribute('data-soilife-dropdown', 'true');

      // Placeholder option (non-selectable)
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select ' + categoryName + '...';
      placeholder.disabled = true;
      select.appendChild(placeholder);

      // Build product options first, then skip option last
      var skipOption = null;
      optionEls.forEach(function(optEl) {
        var value = optEl.dataset.value;
        var isSkip = value.indexOf('No ') === 0;

        if (isSkip) {
          skipOption = value;
          return; // add it last
        }

        var option = document.createElement('option');
        option.value = value;

        var price = individualPrices[value];
        var badge = OPTION_BADGES[value];

        // Format: "5L - $99.00" with badge text
        // Extract just the size from the value (e.g. "M+F 5L" → "5L")
        var sizePart = value.replace(/^(M\+F|Kelp|Compost)\s*/i, '');
        var text = sizePart;
        if (price !== undefined && price > 0) {
          text += '  ·  ' + formatMoney(price);
        }
        if (badge) {
          text += '  ★ ' + badge.text;
        }
        option.textContent = text;

        select.appendChild(option);
      });

      // Add skip/none option at the end
      if (skipOption) {
        var noneOpt = document.createElement('option');
        noneOpt.value = skipOption;
        noneOpt.textContent = 'None - Add a 2nd item for 6% off, or 3rd for 12% off';
        select.appendChild(noneOpt);
      }

      wrapper.appendChild(select);

      // Insert after the label
      var label = field.querySelector('.x-variant-picker__label, .x-form-label');
      if (label) {
        label.insertAdjacentElement('afterend', wrapper);
      } else {
        field.appendChild(wrapper);
      }

      function updateWrapperState() {
        var val = select.value;
        var isSkip = !val || val.indexOf('No ') === 0;
        if (isSkip) {
          wrapper.classList.add('soilife-dropdown-wrapper--skip');
          wrapper.classList.remove('soilife-dropdown-wrapper--active');
        } else {
          wrapper.classList.remove('soilife-dropdown-wrapper--skip');
          wrapper.classList.add('soilife-dropdown-wrapper--active');
        }
      }

      // Sync dropdown → hidden radio
      select.addEventListener('change', function() {
        var selectedValue = this.value;
        var radios = field.querySelectorAll('input[type="radio"]');
        radios.forEach(function(radio) {
          if (radio.value === selectedValue) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        updateWrapperState();
      });

      // Rename the step label to just the friendly product name (Kelp -> Kelp Power,
      // Compost -> Compost Microbes). We DROP Foxify's ": <value>" suffix: it was
      // captured once and went stale when our custom dropdown/default changed the
      // selection (label read "M+F 1L" while the dropdown was on 5L). The dropdown
      // below already shows the selected size.
      var stepLabel = field.querySelector('.x-variant-picker__label, .x-form-label');
      if (stepLabel && stepNames[fieldIndex]) {
        stepLabel.textContent = stepNames[fieldIndex];
      }

      // "Most popular" badge on the primary product. white-space:nowrap keeps the
      // pill text on ONE line (it was breaking to "MOST / POPULAR"); if the row is
      // too narrow the whole pill wraps below the label as a single neat unit.
      if (fieldIndex === 0 && stepLabel && !stepLabel.querySelector('.soilife-popular-tag')) {
        var popTag = document.createElement('span');
        popTag.className = 'soilife-popular-tag';
        popTag.textContent = '★ Most popular';
        popTag.style.cssText = 'display:inline-block;white-space:nowrap;margin-left:8px;padding:3px 10px;border-radius:20px;background:#9ec658;color:#113B2B;font-family:"Poppins",sans-serif;font-size:10.5px;font-weight:700;letter-spacing:.3px;text-transform:uppercase;vertical-align:middle;';
        stepLabel.appendChild(popTag);
      }

      // Deterministic defaults: mandatory Microbes + Feeder -> SMALLEST size (1L);
      // optional Kelp / Compost -> None. (Foxify otherwise renders an arbitrary size first, e.g. 5L.)
      function litres(val) {
        var m = String(val).match(/(\d+)\s*L/);
        return m ? parseInt(m[1], 10) : 9999;
      }
      function applyDefault() {
        var desiredDefault = null;
        if (fieldIndex === 0) {
          var picks = Array.prototype.map.call(select.options, function (o) { return o.value; })
            .filter(function (v) { return v && v.indexOf('No ') !== 0; });
          // Item 6: load in a converting state — default to the best-seller
          // (now M+F 1L) so the page lands on the smallest/entry size; price still shows.
          desiredDefault = picks.indexOf('M+F 1L') !== -1
            ? 'M+F 1L'
            : picks.sort(function (a, b) { return litres(a) - litres(b); })[0];
        } else if (skipOption) {
          desiredDefault = skipOption;
        }
        if (desiredDefault && select.value !== desiredDefault) {
          select.value = desiredDefault;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      applyDefault();
      // Re-assert after Foxify finishes its own init (it may reselect a default)
      setTimeout(applyDefault, 350);

      updateWrapperState();
    });
  }

  function rearrangeLayout() {
    var descBullets = document.querySelector('#x-zq6zgi94');
    var descText = document.querySelector('#x-y8vy55d3');
    var collapsible = document.querySelector('#x-ivdka5ns');

    if (!descBullets || !descText || !collapsible) return;

    // Get existing Ingredients collapsible to clone its exact structure
    var ingredientsBlock = document.querySelector('#x-6rsawine');
    if (!ingredientsBlock) return;

    // Clone the Ingredients block as a template
    var descBlock = ingredientsBlock.cloneNode(true);
    descBlock.id = 'x-desc-collapsible';
    descBlock.className = 'x-collapsible-content x-element';

    // Replace the title text
    var titleSpan = descBlock.querySelector('.x-collapsible__button > span:first-child');
    if (titleSpan) titleSpan.textContent = 'Description';

    // Replace the content inside the collapsible panel
    var contentWrapper = descBlock.querySelector('.x-collapsible__content-wrapper');
    if (contentWrapper) {
      contentWrapper.innerHTML = '<div class="x-collapsible__content x-layout-auto"></div>';
      var contentInner = contentWrapper.querySelector('.x-collapsible__content');
      contentInner.appendChild(descBullets);
      contentInner.appendChild(descText);
    }

    // Ensure the cloned tab starts collapsed
    var tab = descBlock.querySelector('x-collapsible-tab');
    if (tab) tab.classList.remove('is-open');

    // Insert as first child of the collapsible wrapper
    collapsible.insertBefore(descBlock, ingredientsBlock);

    // Wire up toggle (since Foxify JS already ran before our injection)
    var trigger = descBlock.querySelector('[data-trigger="true"]');
    var panel = contentWrapper;

    if (trigger && panel) {
      panel.style.maxHeight = '0';
      panel.style.overflow = 'hidden';
      panel.style.transition = 'max-height 0.3s ease';

      trigger.addEventListener('click', function() {
        var isOpen = tab.classList.contains('is-open');
        if (isOpen) {
          panel.style.maxHeight = '0';
          tab.classList.remove('is-open');
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          tab.classList.add('is-open');
        }
      });
    }
  }

  // Individual product data - fetched once, used for cart + pricing
  var individualProducts = {};
  var PRODUCT_HANDLES = ['soil-microbes-feeder', 'kelp-power', 'compost-microbes'];
  // Map dropdown option prefixes to product handles
  var OPTION_TO_HANDLE = {
    'M+F': 'soil-microbes-feeder',
    'Kelp': 'kelp-power',
    'Compost': 'compost-microbes'
  };

  function fetchIndividualProducts() {
    return Promise.all(PRODUCT_HANDLES.map(function(handle) {
      return fetch('/products/' + handle + '.js').then(function(r) { return r.json(); });
    })).then(function(products) {
      products.forEach(function(p) { individualProducts[p.handle] = p; });
    }).catch(function() {});
  }

  function findIndividualVariant(optionValue) {
    // Map option like "M+F 5L" → soil-microbes-feeder variant containing "5L"
    var prefix = Object.keys(OPTION_TO_HANDLE).find(function(p) {
      return optionValue.indexOf(p) === 0;
    });
    if (!prefix) return null;

    var handle = OPTION_TO_HANDLE[prefix];
    var product = individualProducts[handle];
    if (!product) return null;

    // Extract the size part: "M+F 5L" → "5L"
    var sizePart = optionValue.replace(prefix, '').trim();

    // Find the variant whose title contains the size
    var variant = product.variants.find(function(v) {
      return v.title.indexOf(sizePart) !== -1;
    });

    return variant || product.variants[0];
  }

  function initPricing() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));

    // Create redesigned running total + savings progress
    var totalEl = document.createElement('div');
    totalEl.className = 'bundle-running-total';
    totalEl.style.opacity = '0';
    totalEl.style.transition = 'opacity .25s ease';
    totalEl.innerHTML =
      '<div class="bundle-total-inner">' +
        '<div class="bundle-total-prices">' +
          '<span class="bundle-total-amount"></span>' +
          '<span class="bundle-total-compare"></span>' +
        '</div>' +
        '<span class="bundle-total-savings"></span>' +
      '</div>' +
      '<div class="bundle-microcopy"></div>';

    var buyButton = document.querySelector(BUY_BUTTON_SELECTOR);
    if (buyButton) {
      buyButton.insertAdjacentElement('beforebegin', totalEl);
    } else {
      picker.insertAdjacentElement('afterend', totalEl);
    }

    // Item 2: glanceable rating aggregate at the decision point (above price).
    // TODO (Phase 2): wire the count/score to the live Judge.me aggregate.
    if (!document.querySelector('.soilife-buybox-rating')) {
      var ratingEl = document.createElement('div');
      ratingEl.className = 'soilife-buybox-rating';
      ratingEl.style.cssText = 'display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:8px;margin:0 0 10px;font-family:"Poppins",sans-serif;';
      ratingEl.innerHTML =
        '<span style="color:#D4A017;font-size:17px;letter-spacing:1px;line-height:1;">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
        '<span style="font-size:13.5px;font-weight:600;color:#113B2B;">227 reviews</span>' +
        '<span style="font-size:13px;color:#7A8A76;">&middot; 1,800+ happy gardeners</span>';
      totalEl.parentNode.insertBefore(ratingEl, totalEl);
    }

    // Prominent cost-per-application callout (created here; injectProductAccordions
    // later relocates it to sit BELOW the Description/Ingredients/Application dropdowns).
    if (buyButton && !document.querySelector('.bundle-cpa')) {
      var cpaEl = document.createElement('div');
      cpaEl.className = 'bundle-cpa';
      cpaEl.style.cssText = 'text-align:center;margin:6px 0 14px;font-family:Poppins,sans-serif;opacity:0;transition:opacity .25s ease;';
      cpaEl.innerHTML =
        '<div style="font-size:26px;font-weight:800;color:#113B2B;line-height:1.05;">From just $0.80 / m&sup2;</div>' +
        '<div style="font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#4A5D52;margin-top:3px;">Cost per application</div>';
      buyButton.insertAdjacentElement('beforebegin', cpaEl);
    }

    function getCurrentOptions() {
      return fields.map(function(field) {
        var soiSelect = field.querySelector('select[data-soilife-dropdown]');
        if (soiSelect) return soiSelect.value;
        var fieldType = field.dataset.fieldType;
        if (fieldType === 'button') {
          var checked = field.querySelector('input:checked');
          return checked ? checked.value : '';
        }
        var select = field.querySelector('select');
        return select ? select.value : '';
      });
    }

    function update() {
      var currentOptions = getCurrentOptions();

      // Count active (non-skip) items and sum individual prices
      var activeCount = 0;
      var subtotal = 0;
      currentOptions.forEach(function(opt) {
        if (opt && opt.indexOf('No ') !== 0) {
          activeCount++;
          var price = individualPrices[opt] || 0;
          subtotal += price;
        }
      });

      var totalAmount = totalEl.querySelector('.bundle-total-amount');
      var totalCompare = totalEl.querySelector('.bundle-total-compare');
      var totalSavings = totalEl.querySelector('.bundle-total-savings');
      var microcopy = totalEl.querySelector('.bundle-microcopy');

      // Bundle pricing: the 6% / 12% discount is a Shopify AUTOMATIC discount
      // applied to the individual products at checkout. Anchor BOTH the
      // strikethrough and the saving to the regular selling subtotal (the sum of
      // the chosen individual products) and the tier %, so the compare price, the
      // dollar saving and the "% off" always reconcile with each other and with
      // the "applied automatically at checkout" microcopy below.
      //
      // Do NOT anchor to the selector variant's compare_at_price (RRP): that
      // mixed a per-product markdown into the bundle line and showed a
      // contradictory "36% off" ($199.90 RRP baseline) against the "12% off"
      // message (real subtotal $146.40 -> $128.83). Pricing fix 2026-07-04.
      if (activeCount > 0) {
        var discountPct = 0;
        if (activeCount >= 3) discountPct = 12;
        else if (activeCount >= 2) discountPct = 6;
        var discountAmount = Math.round(subtotal * discountPct / 100);
        totalAmount.textContent = formatMoney(subtotal - discountAmount);
        if (discountPct > 0) {
          totalCompare.textContent = formatMoney(subtotal);
          totalSavings.innerHTML = 'Save ' + formatMoney(discountAmount) + ' <span class="savings-pct">(' + discountPct + '% off)</span>';
          totalSavings.style.display = '';
        } else {
          totalCompare.textContent = '';
          totalSavings.innerHTML = '';
          totalSavings.style.display = 'none';
        }
      } else {
        totalAmount.textContent = '$0.00';
        totalCompare.textContent = '';
        totalSavings.innerHTML = '';
        totalSavings.style.display = 'none';
      }

      // Micro-copy: loss-aversion next-tier nudge (progress framing toward 12%).
      if (activeCount >= 3) {
        microcopy.innerHTML = '&#127881; Best value unlocked. <strong>12% off</strong> applied automatically at checkout';
      } else if (activeCount === 2) {
        microcopy.innerHTML = '&#9989; <strong>6% off</strong> unlocked. Add 1 more product to reach <strong>12% off</strong>';
      } else if (activeCount === 1) {
        microcopy.innerHTML = '&#128274; Add a 2nd product to unlock <strong>6% off</strong>, or a 3rd for <strong>12% off</strong>';
      } else {
        microcopy.innerHTML = 'Select products above to start your bundle';
      }

      // Keep the mobile sticky bar's price in sync with the live total.
      var stickyPrice = document.querySelector('.soilife-sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = totalAmount.textContent;

      // --- Own the Add-to-Cart enabled state (fixes the "stuck disabled" bug) ---
      // The Foxify variant picker disables the buy button via setUnavailable() whenever
      // the selected combination (e.g. a "No Kelp / No Compost" skip combo) maps to
      // an unavailable selector variant. But this bundle adds the INDIVIDUAL products,
      // which are purchasable, so the button must be enabled whenever >=1 real product
      // is chosen. Foxify disables via the `disabled` ATTRIBUTE, so we must
      // removeAttribute — a `.disabled = false` property toggle alone would not clear it.
      if (buyButton) {
        if (activeCount > 0) {
          buyButton.disabled = false;
          buyButton.removeAttribute('disabled');
        } else {
          buyButton.disabled = true;
          buyButton.setAttribute('disabled', 'true');
        }
      }
    }

    update();

    // Fade the price + CPA blocks in only once built and populated, so they
    // appear already-centered instead of visibly reflowing left-to-center.
    requestAnimationFrame(function () {
      totalEl.style.opacity = '1';
      var cpaReveal = document.querySelector('.bundle-cpa');
      if (cpaReveal) cpaReveal.style.opacity = '1';
    });

    picker.addEventListener('change', function() {
      setTimeout(update, 50);
    });

    if (window.Foxify && window.Foxify.Events) {
      var productId = picker.dataset.productId;
      if (productId) {
        Foxify.Events.on(productId + '__VARIANT_CHANGE', function() {
          setTimeout(update, 50);
        });
      }
    }
  }

  function overrideBuyButton() {
    var buyButton = document.querySelector(BUY_BUTTON_SELECTOR);
    if (!buyButton) return;

    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));

    // Prevent Foxify's native form submission
    var form = buyButton.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    var ADD_LABEL = (buyButton.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';

    // Two matched buttons. "Add to cart" = white default, soilife light-green
    // on hover. "View cart" = dark green default, soilife orange on hover.
    // Colours/size forced with !important so they beat the Foxify button styles.
    var BTN_LAYOUT = 'display:block;width:100%;box-sizing:border-box;padding:16px 24px;border-radius:60px;font-family:"Poppins",sans-serif;font-size:16px;font-weight:600;line-height:1.2;cursor:pointer;text-align:center;transition:background 0.2s ease,color 0.2s ease,border-color 0.2s ease;';
    function soiSetBtn(el, bg, fg, bd) {
      el.style.setProperty('background', bg, 'important');
      el.style.setProperty('color', fg, 'important');
      el.style.setProperty('border', '2px solid ' + bd, 'important');
    }
    // PRIMARY: "Add to cart" is the solid, highest-contrast CTA — the single
    // dominant action. (Previously a white outline/ghost button, which research
    // shows suppresses the primary action.) Hover -> soilife light green.
    buyButton.style.cssText = BTN_LAYOUT + 'margin:0;';
    buyButton.style.setProperty('width', '100%', 'important');
    buyButton.style.setProperty('padding', '16px 24px', 'important');
    buyButton.style.setProperty('border-radius', '60px', 'important');
    soiSetBtn(buyButton, '#113B2B', '#fff', '#113B2B');
    buyButton.addEventListener('mouseenter', function () { soiSetBtn(buyButton, '#9ec658', '#113B2B', '#9ec658'); });
    buyButton.addEventListener('mouseleave', function () { soiSetBtn(buyButton, '#113B2B', '#fff', '#113B2B'); });

    // SECONDARY: "View cart" is an outline/ghost button so it can't outshout the
    // primary. Orange is reserved for the Checkout CTA inside the cart/drawer.
    if (!document.getElementById('soilife-checkout-btn')) {
      var checkoutBtn = document.createElement('button');
      checkoutBtn.id = 'soilife-checkout-btn';
      checkoutBtn.type = 'button';
      checkoutBtn.textContent = 'View cart';
      checkoutBtn.style.cssText = BTN_LAYOUT + 'margin-top:10px;';
      soiSetBtn(checkoutBtn, '#fff', '#113B2B', '#113B2B');
      checkoutBtn.addEventListener('mouseenter', function () { soiSetBtn(checkoutBtn, '#F2F7EC', '#113B2B', '#9ec658'); });
      checkoutBtn.addEventListener('mouseleave', function () { soiSetBtn(checkoutBtn, '#fff', '#113B2B', '#113B2B'); });
      checkoutBtn.addEventListener('click', function (e) { e.preventDefault(); window.location.href = '/cart'; });
      if (buyButton.parentNode) buyButton.parentNode.insertBefore(checkoutBtn, buyButton.nextSibling);

      // Reassurance under the buy buttons. flex-wrap + each claim a nowrap unit, so
      // on narrow mobile it wraps as WHOLE phrases (no orphaned "checkout") instead
      // of breaking mid-phrase.
      var guarantee = document.createElement('div');
      guarantee.className = 'soilife-buybox-guarantee';
      guarantee.style.cssText = 'display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:5px 14px;margin-top:12px;font-family:"Poppins",sans-serif;font-size:12.5px;font-weight:500;color:#4A5D52;text-align:center;line-height:1.45;';
      guarantee.innerHTML =
        '<span style="display:inline-flex;align-items:center;gap:6px;white-space:nowrap;"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2f7d32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg><strong>100% Satisfaction Protection</strong></span>' +
        '<span style="white-space:nowrap;">Secure checkout</span>';
      if (checkoutBtn.parentNode) checkoutBtn.parentNode.insertBefore(guarantee, checkoutBtn.nextSibling);
    }

    buyButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Read the selected options live (the picker may have re-rendered).
      var liveFields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
      if (!liveFields.length) liveFields = fields;
      var rawVals = liveFields.map(function(field) {
        var soiSelect = field.querySelector('select[data-soilife-dropdown]');
        var val = soiSelect ? soiSelect.value : '';
        if (!val) {
          var fieldType = field.dataset.fieldType;
          if (fieldType === 'button') {
            var checked = field.querySelector('input:checked');
            val = checked ? checked.value : '';
          } else {
            var sel = field.querySelector('select');
            val = sel ? sel.value : '';
          }
        }
        return val;
      });

      // Build the chosen INDIVIDUAL product variants (skip any "No ..." slot).
      // The cart shows separate, named products; the 6% / 12% bundle discount
      // is applied automatically by the store discounts.
      function buildItems() {
        var items = [];
        rawVals.forEach(function(val) {
          if (val && val.indexOf('No ') !== 0) {
            var v = findIndividualVariant(val);
            if (v) items.push({ id: v.id, quantity: 1 });
          }
        });
        return items;
      }

      function addItems(items) {
        if (!items.length) {
          if (window.console) console.error('[soilife-atc] no items for', rawVals.join(' / '));
          buyButton.disabled = false;
          buyButton.textContent = ADD_LABEL;
          return;
        }
        buyButton.disabled = true;
        buyButton.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(res) {
          if (!res.ok) { throw new Error('cart/add ' + res.status); }
          return res.json();
        })
        .then(function() {
          // Re-usable: reset the button so the customer can change the combo and
          // add again, or add more (re-adding the same combo increments its
          // quantity). The slide-in cart confirm offers View Cart / Checkout.
          buyButton.disabled = false;
          buyButton.textContent = 'Added';
          setTimeout(function() {
            if (!buyButton.disabled) buyButton.textContent = ADD_LABEL;
          }, 1800);
        })
        .catch(function(err) {
          if (window.console) console.error('[soilife-atc] add failed', err);
          buyButton.textContent = 'Error, try again';
          buyButton.disabled = false;
        });
      }

      // Ensure individual product data is loaded, then add.
      var ready = PRODUCT_HANDLES.every(function(h) { return individualProducts[h]; });
      if (ready) {
        addItems(buildItems());
      } else {
        buyButton.disabled = true;
        buyButton.textContent = 'Adding...';
        fetchIndividualProducts().then(function() { addItems(buildItems()); });
      }
    }, true);
  }

  function fixFaqSection() {
    var faqGrid = document.querySelector('#x-6ul9fj94');
    if (!faqGrid) return;

    // Override Foxify's fixed height on the FAQ grid
    faqGrid.style.setProperty('height', 'auto', 'important');
    faqGrid.style.setProperty('min-height', 'auto', 'important');

    // Fix heading cell
    var headingCell = document.querySelector('#x-4lw1d9so');
    if (headingCell) {
      headingCell.style.setProperty('height', 'auto', 'important');
    }

    // Fix both FAQ cells - align to top
    var leftFaq = document.querySelector('#x-mnj8uz82');
    var rightFaq = document.querySelector('#x-eyvuj83u');

    [leftFaq, rightFaq].forEach(function(cell) {
      if (!cell) return;
      cell.style.setProperty('height', 'auto', 'important');
      cell.style.setProperty('align-items', 'flex-start', 'important');
      cell.style.setProperty('justify-content', 'flex-start', 'important');
    });
  }

  function fixProductGridSection() {
    // Only fix on tablet/mobile (≤ 1099px)
    if (window.innerWidth > 1099) return;

    var section = document.querySelector('#x-b149iew6');
    if (!section) return;

    // Fix section min-height
    section.style.setProperty('min-height', 'auto', 'important');
    section.style.setProperty('height', 'auto', 'important');

    // Fix the grid container - switch to flex column to prevent overlap
    var container = section.querySelector('.x-container-custom');
    if (container) {
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('flex-direction', 'column', 'important');
    }

    // Fix the heading - place it first, full width, no overlap
    var heading = document.querySelector('#x-7bisbnvi');
    if (heading) {
      heading.style.setProperty('width', '100%', 'important');
      heading.style.setProperty('margin', '0 0 16px 0', 'important');
      heading.style.setProperty('justify-self', 'center', 'important');
      heading.style.setProperty('align-self', 'start', 'important');
      heading.style.setProperty('text-align', 'center', 'important');
      heading.style.setProperty('order', '-1', 'important');
    }

    // Fix the product list - remove negative margins
    var productList = document.querySelector('#x-0gildmkd');
    if (productList) {
      productList.style.setProperty('margin', '0', 'important');
      productList.style.setProperty('align-self', 'stretch', 'important');
      productList.style.setProperty('justify-self', 'stretch', 'important');
      productList.style.setProperty('width', '100%', 'important');
    }
  }

  // Self-contained Description / Ingredients / Application dropdowns built from
  // scratch and placed under the buy box. Foxify's own collapsibles do NOT render
  // on this template, so we do not depend on them at all. Application folds in the
  // "what you receive + mixing ratios" content (the old clarity text).
  var SOILIFE_ACCORDIONS = [
    { title: 'Description', html:
      '<ul class="soilife-acc__list">' +
        '<li>Join thousands of gardeners who have discovered the secret.</li>' +
        '<li>Healthy soil = happy plants = happy you.</li>' +
        '<li>100% natural. Zero chemicals. Maximum results.</li>' +
      '</ul>' +
      '<p>For over 14 years, SoiLife has been the secret weapon of successful gardeners and farmers across Australia. Now it is your turn to experience what happens when you feed your soil the living nutrients it craves.</p>' +
      '<p>Reach out if you have any questions; we are here to help.</p>'
    },
    { title: 'Ingredients', html:
      '<p><strong>Bacteria:</strong> Pseudomonas, Actinomycetes, Bacillus, gram positive, gram negative, methane oxidisers, sulphur reducers, true anaerobes.</p>' +
      '<p><strong>Eukaryotes:</strong> Protozoa, mycorrhizal fungi.</p>' +
      '<p><strong>Elements:</strong> Nitrogen (N), Phosphorous (P), Boron (B), Calcium (Ca), Cobalt (Co), Iron (Fe), Magnesium (Mg), Manganese (Mn), Molybdenum (Mo), Sodium (Na), Sulphur (S), Zinc (Zn).</p>'
    },
    { title: 'Application', html:
      '<p><strong>Mix ratio:</strong> 250ml Microbes + 250ml Feeder in 9L water. This covers about 25m&sup2; (or 12 x 2m for fruit trees).</p>' +
      '<p><strong>5L and 20L bottles:</strong> these come with a 4x strength Microbe Feeder Concentrate, so you use the same 250ml Microbes but much less feeder. It also keeps postage and plastic down.</p>' +
      '<ul class="soilife-acc__list">' +
        '<li>5L Soil Microbes comes with a 1L Microbe Feeder Concentrate. Use 250ml Microbes + 50ml Feeder Concentrate.</li>' +
        '<li>20L Soil Microbes comes with a 5L Microbe Feeder Concentrate (4x strength). Use 250ml Microbes + 60ml Feeder Concentrate.</li>' +
      '</ul>' +
      '<p><strong>Per square metre:</strong> 10ml Microbes + 10ml Feeder. With the Feeder Concentrate from the 5L and 20L bottles, use 10ml Microbes + 2.5ml Feeder Concentrate.</p>' +
      '<p><strong>How often:</strong> reapply every 2 to 4 weeks through the growing season. Rates differ for lawns, gardens and pots, and the instructions are always on the Microbe bottle. For help with the ratio or application, email us anytime.</p>'
    }
  ];

  function injectProductAccordions() {
    if (document.querySelector('.soilife-acc-group')) return;

    var buyButton = document.querySelector(BUY_BUTTON_SELECTOR);
    if (!buyButton) return;

    // Anchor under the buy-box reassurance line (fallback: after the View cart
    // button, else after the buy button).
    var anchor = document.querySelector('.soilife-buybox-guarantee') ||
                 document.getElementById('soilife-checkout-btn') ||
                 buyButton;

    var group = document.createElement('div');
    group.className = 'soilife-acc-group';
    group.style.cssText = 'margin:22px 0 4px;border-bottom:1px solid #E3EADD;font-family:"Poppins",sans-serif;';

    var CHEVRON = '<svg class="soilife-acc__chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7CB342" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="transition:transform .3s ease;flex-shrink:0;"><polyline points="6 9 12 15 18 9"/></svg>';

    SOILIFE_ACCORDIONS.forEach(function (it) {
      var item = document.createElement('div');
      item.className = 'soilife-acc';
      item.style.cssText = 'border-top:1px solid #E3EADD;';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'soilife-acc__btn';
      btn.style.cssText = 'width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 2px;background:none;border:none;cursor:pointer;font-family:"Poppins",sans-serif;font-size:15px;font-weight:600;color:#113B2B;text-align:left;';
      btn.innerHTML = '<span>' + it.title + '</span>' + CHEVRON;

      var panel = document.createElement('div');
      panel.className = 'soilife-acc__panel';
      panel.style.cssText = 'max-height:0;overflow:hidden;transition:max-height .3s ease;';

      var inner = document.createElement('div');
      inner.className = 'soilife-acc__inner';
      inner.style.cssText = 'padding:0 2px 16px;font-family:"Poppins",sans-serif;font-size:14px;line-height:1.65;color:#4A5D52;';
      inner.innerHTML = it.html;
      // Tidy the injected lists.
      Array.prototype.forEach.call(inner.querySelectorAll('.soilife-acc__list'), function (ul) {
        ul.style.cssText = 'margin:0 0 10px;padding-left:18px;';
      });
      Array.prototype.forEach.call(inner.querySelectorAll('p'), function (p) {
        p.style.margin = '0 0 10px';
      });

      panel.appendChild(inner);
      btn.addEventListener('click', function () {
        var open = panel.style.maxHeight && panel.style.maxHeight !== '0px';
        if (open) {
          panel.style.maxHeight = '0';
          btn.querySelector('.soilife-acc__chev').style.transform = '';
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.querySelector('.soilife-acc__chev').style.transform = 'rotate(180deg)';
        }
      });

      item.appendChild(btn);
      item.appendChild(panel);
      group.appendChild(item);
    });

    anchor.insertAdjacentElement('afterend', group);

    // Per design: relocate the cost-per-application callout to sit BELOW the
    // Description / Ingredients / Application dropdowns. initPricing() builds it
    // above the buy button; now that the accordion group exists, move it here.
    var cpaBlock = document.querySelector('.bundle-cpa');
    if (cpaBlock) {
      cpaBlock.style.margin = '20px 0 4px';
      group.insertAdjacentElement('afterend', cpaBlock);
    }
  }

  function replaceTwoPartSection() {
    var oldSection = document.getElementById('x-q8ga3h6q');
    if (!oldSection || document.querySelector('.soilife-two-part') || !window.soilifeTwoPartImgs) return;

    var panels = [
      { alt: 'The power packed two-part formula - Part A: Soil Microbes, Part B: Microbes Feeder', color: 'purple' },
      { alt: 'What Is Compost Microbes? A concentrated blend of beneficial bacteria and fungi', color: 'orange' },
      { alt: 'What Is Kelp Power? A premium seaweed extract sourced from Australian kelp', color: 'green' }
    ];

    var wrapper = document.createElement('div');
    wrapper.className = 'soilife-two-part';
    window.soilifeTwoPartImgs.forEach(function(url, i) {
      wrapper.innerHTML +=
        '<div class="soilife-two-part__panel soilife-two-part__panel--' + panels[i].color + '">' +
          '<img src="' + url + '" alt="' + panels[i].alt + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
        '</div>';
    });

    oldSection.insertAdjacentElement('afterend', wrapper);
  }

  /* FAQ section now handled by soilife-faq-shared.js */

  function injectSocialProofBar() {
    var productSection = document.querySelector('#x-s4qcim0s');
    if (!productSection) return;
    if (document.querySelector('.soilife-social-proof')) return; // already injected

    var bar = document.createElement('div');
    bar.className = 'soilife-social-proof';
    // The ★ rating + "227 reviews · 1,800+ happy gardeners" now live in the chip
    // right by the buy box, so this lower bar drops them (no doubling) and carries
    // only the credibility claims that aren't shown elsewhere.
    bar.innerHTML =
      '<span>Scientifically Proven</span>' +
      '<span class="soilife-social-proof__sep">|</span>' +
      '<span>14+ Years in Development</span>';

    productSection.insertAdjacentElement('afterend', bar);
  }

  function enhanceSocialProof() {
    // Find the existing "★★★★★ 227 Reviews | 1800+ Happy Customers" element and enhance it
    var reviewEls = document.querySelectorAll('#x-s4qcim0s .x-text, #x-s4qcim0s .x-rte');
    reviewEls.forEach(function(el) {
      if (el.textContent && el.textContent.indexOf('Reviews') !== -1 && el.textContent.indexOf('Happy') !== -1) {
        el.className += ' soilife-social-proof';
        el.innerHTML =
          '<span class="soilife-social-proof__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
          '<strong>227 Reviews</strong>' +
          '<span class="soilife-social-proof__sep">|</span>' +
          '<span>1800+ Happy Customers</span>' +
          '<span class="soilife-social-proof__sep">|</span>' +
          '<span>Scientifically Proven</span>' +
          '<span class="soilife-social-proof__sep">|</span>' +
          '<span>14+ Years in Development</span>';
      }
    });
  }

  function reorderSections() {
    // Move testimonials (#x-dm87cj9j) right after the product section
    var productSection = document.querySelector('#x-s4qcim0s');
    var testimonials = document.querySelector('#x-dm87cj9j');

    // Order: product → social proof bar → testimonials
    var socialBar = document.querySelector('.soilife-social-proof');
    if (productSection && testimonials) {
      if (socialBar) {
        productSection.insertAdjacentElement('afterend', socialBar);
        socialBar.insertAdjacentElement('afterend', testimonials);
      } else {
        productSection.insertAdjacentElement('afterend', testimonials);
      }

      // Reinitialize Swiper after DOM move
      setTimeout(function() {
        var swiperEl = testimonials.querySelector('.swiper, [data-swiper]');
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.update();
        }
      }, 200);
    }

    // Forcefully remove hidden sections from DOM
    // Include wrapper sections that have colored backgrounds
    var hiddenIds = [
      'x-o267m4z4', // orphaned testimonials heading (green bg)
      'x-lfjiui8e', // use cases carousel (has bg image)
      'x-yhjend1t', // key features grid
      'x-dqukfrq8', // additional details (blue/purple bg!)
      'x-wwawjjvk', // summary CTA
      'x-x5yh2yki', // FAQ WRAPPER section (dark green bg!) - wraps x-6ul9fj94
      'x-6ul9fj94', // Foxify FAQ inner
      'x-b149iew6'  // Foxify product grid
    ];
    hiddenIds.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  function injectDiscountMessaging() {
    var picker = document.querySelector(PICKER_SELECTOR);

    // --- 3a: Banner above bundle picker ---
    var banner = document.createElement('div');
    banner.className = 'soilife-discount-banner';
    banner.innerHTML =
      '<div class="soilife-discount-banner__inner">' +
        '<span class="soilife-discount-banner__icon">&#127873;</span>' +
        '<div class="soilife-discount-banner__text">' +
          '<strong>Bundle &amp; save even more!</strong>' +
          '<span class="soilife-discount-banner__tiers">' +
            '<span class="soilife-discount-tier">Buy 2 items &rarr; <strong>6% off</strong></span>' +
            '<span class="soilife-discount-tier__sep">|</span>' +
            '<span class="soilife-discount-tier">Buy 3 items &rarr; <strong>12% off</strong></span>' +
          '</span>' +
        '</div>' +
      '</div>';

    if (picker) {
      picker.insertAdjacentElement('beforebegin', banner);
    }

    // --- 3b: Sticky announcement bar --- (disabled: global shipping bar handles this)
    if (false && !sessionStorage.getItem('soilife_sticky_dismissed')) {
      var stickyBar = document.createElement('div');
      stickyBar.className = 'soilife-sticky-bar';
      stickyBar.innerHTML =
        '<div class="soilife-sticky-bar__inner">' +
          '<span class="soilife-sticky-bar__text">' +
            'Bundle &amp; Save: <strong>6% off 2 items</strong> or <strong>12% off 3 items</strong> &mdash; applied automatically at checkout' +
          '</span>' +
          '<button class="soilife-sticky-bar__close" aria-label="Dismiss">&times;</button>' +
        '</div>';

      document.body.insertAdjacentElement('afterbegin', stickyBar);

      // Compensate for sticky bar height
      var barHeight = stickyBar.offsetHeight || 44;
      document.body.style.paddingTop = barHeight + 'px';

      stickyBar.querySelector('.soilife-sticky-bar__close').addEventListener('click', function() {
        stickyBar.style.transform = 'translateY(-100%)';
        document.body.style.paddingTop = '';
        sessionStorage.setItem('soilife_sticky_dismissed', '1');
        setTimeout(function() { stickyBar.remove(); }, 300);
      });
    }

  }

  function preSelectDefaults() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
    var defaults = ['M+F 1L', 'No Kelp', 'No Compost'];

    fields.forEach(function(field, index) {
      if (index >= defaults.length) return;
      var target = defaults[index];

      // Set dropdown value and trigger sync
      var soiSelect = field.querySelector('select[data-soilife-dropdown]');
      if (soiSelect) {
        soiSelect.value = target;
        soiSelect.dispatchEvent(new Event('change', { bubbles: false }));
      }

      // Also set the hidden radio directly as fallback
      var options = field.querySelectorAll('.x-variant-picker__option');
      options.forEach(function(opt) {
        if (opt.dataset.value === target) {
          var radio = opt.querySelector('input[type="radio"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  function injectAlsoBought() {
    var picker = document.querySelector(PICKER_SELECTOR);

    // Map picker step index to product handle
    var stepProducts = [
      { handle: 'soil-microbes-feeder', label: 'Soil Microbes + Feeder', skipPrefix: 'No M' },
      { handle: 'kelp-power', label: 'Kelp Power', skipPrefix: 'No Kelp' },
      { handle: 'compost-microbes', label: 'Compost Microbes', skipPrefix: 'No Compost' }
    ];

    // Fetch all product data upfront
    var fetches = stepProducts.map(function(sp) {
      return fetch('/products/' + sp.handle + '.js').then(function(r) { return r.json(); });
    });

    Promise.all(fetches).then(function(products) {
      // Store product data keyed by handle
      var productData = {};
      products.forEach(function(p) { productData[p.handle] = p; });

      // Create section container
      var section = document.createElement('section');
      section.className = 'soilife-also-bought';

      // Insert after the product section
      var productSection = document.querySelector('.x-main .x-section:first-child');
      if (productSection) {
        productSection.insertAdjacentElement('afterend', section);
      } else {
        document.querySelector('.x-main').appendChild(section);
      }

      function getActiveSteps() {
        if (!picker) return [true, false, false];
        var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
        return fields.map(function(field) {
          var fieldType = field.dataset.fieldType;
          var val = '';
          if (fieldType === 'button') {
            var checked = field.querySelector('input:checked');
            val = checked ? checked.value : '';
          } else {
            var sel = field.querySelector('select');
            val = sel ? sel.value : '';
          }
          return val && val.indexOf('No ') !== 0;
        });
      }

      function renderSection() {
        var activeSteps = getActiveSteps();
        var activeCount = activeSteps.filter(Boolean).length;

        // Determine which products to suggest (ones NOT currently selected)
        var missing = [];
        var selected = [];
        stepProducts.forEach(function(sp, i) {
          var p = productData[sp.handle];
          if (!p) return;
          if (!activeSteps[i]) {
            missing.push(p);
          } else {
            selected.push(p);
          }
        });

        // Build messaging
        var title = '';
        var subtitle = '';

        if (activeCount >= 3) {
          title = 'You\'re Getting the Best Deal!';
          subtitle = 'All 3 products selected &mdash; <strong>12% off</strong> applies at checkout';
          missing = [];
          stepProducts.forEach(function(sp) {
            var p = productData[sp.handle];
            if (p) missing.push(p);
          });
        } else if (activeCount === 2) {
          title = 'Complete Your Bundle';
          subtitle = 'Add <strong>' + missing[0].title + '</strong> to unlock <strong>12% off</strong> your entire order';
        } else if (activeCount === 1) {
          title = 'Frequently Bought Together';
          if (missing.length === 2) {
            subtitle = 'Add one more for <strong>6% off</strong>, or both for <strong>12% off</strong>';
          } else {
            subtitle = 'Add another product for <strong>6% off</strong>';
          }
        } else {
          title = 'Popular Products';
          subtitle = 'Bundle 2+ items for up to <strong>12% off</strong> + use <strong>SHIP40%</strong> for 40% off shipping!';
        }

        var cards = missing.map(function(p) {
          var img = p.images[0] || '';
          var price = formatMoney(p.price_min);
          var url = '/products/' + p.handle;
          var isSelected = activeCount >= 3;
          return (
            '<a href="' + url + '" class="soilife-also-bought__card' + (isSelected ? ' soilife-also-bought__card--selected' : '') + '">' +
              (isSelected ? '<span class="soilife-ab-card-check">&#10003;</span>' : '') +
              '<div class="soilife-also-bought__img-wrap">' +
                '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' +
              '</div>' +
              '<div class="soilife-also-bought__info">' +
                '<span class="soilife-also-bought__name">' + p.title + '</span>' +
                '<span class="soilife-also-bought__price">From ' + price + '</span>' +
              '</div>' +
            '</a>'
          );
        }).join('');

        section.innerHTML =
          '<h2 class="soilife-also-bought__title">' + title + '</h2>' +
          '<div class="soilife-also-bought__subtitle">' + subtitle + '</div>' +
          '<div class="soilife-also-bought__grid">' + cards + '</div>';
      }

      renderSection();

      // Re-render when variant changes
      if (picker) {
        picker.addEventListener('change', function() {
          setTimeout(renderSection, 80);
        });
        if (window.Foxify && window.Foxify.Events) {
          var productId = picker.dataset.productId;
          if (productId) {
            Foxify.Events.on(productId + '__VARIANT_CHANGE', function() {
              setTimeout(renderSection, 80);
            });
          }
        }
      }
    }).catch(function() {});
  }

  function injectStickyAtc() {
    var buyButton = document.querySelector(BUY_BUTTON_SELECTOR);
    if (!buyButton || document.querySelector('.soilife-sticky-atc')) return;

    // Mobile-only sticky bar. Hidden on desktop and until the real buy button
    // scrolls out of view. Mirrors the live bundle price and re-uses the main
    // Add-to-cart flow (clicks the real button) so there is no duplicated cart
    // logic / money path.
    var style = document.createElement('style');
    style.textContent =
      '.soilife-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:9998;display:none;align-items:center;gap:12px;padding:10px 16px;padding-bottom:calc(10px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -4px 18px rgba(17,59,43,0.14);border-top:1px solid #e8f0e4;transform:translateY(110%);transition:transform .25s ease;}' +
      '.soilife-sticky-atc.is-visible{transform:translateY(0);}' +
      '.soilife-sticky-atc__info{display:flex;flex-direction:column;line-height:1.05;}' +
      '.soilife-sticky-atc__label{font-family:"Poppins",sans-serif;font-size:10.5px;font-weight:600;letter-spacing:.4px;text-transform:uppercase;color:#7A8A76;}' +
      '.soilife-sticky-atc__price{font-family:"Poppins",sans-serif;font-size:19px;font-weight:800;color:#113B2B;}' +
      '.soilife-sticky-atc__btn{flex:1;border:none;border-radius:50px;padding:14px 20px;background:#113B2B;color:#fff;font-family:"Poppins",sans-serif;font-size:15px;font-weight:700;cursor:pointer;}' +
      '.soilife-sticky-atc__btn:active{background:#9ec658;color:#113B2B;}' +
      '@media (min-width:750px){.soilife-sticky-atc{display:none !important;}}' +
      '@media (max-width:749px){.soilife-sticky-atc{display:flex;}}';
    document.head.appendChild(style);

    var bar = document.createElement('div');
    bar.className = 'soilife-sticky-atc';
    bar.innerHTML =
      '<div class="soilife-sticky-atc__info">' +
        '<span class="soilife-sticky-atc__label">Your bundle</span>' +
        '<span class="soilife-sticky-atc__price">$0.00</span>' +
      '</div>' +
      '<button type="button" class="soilife-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    var liveTotal = document.querySelector('.bundle-total-amount');
    var stickyPrice = bar.querySelector('.soilife-sticky-atc__price');
    if (liveTotal && stickyPrice) stickyPrice.textContent = liveTotal.textContent;

    bar.querySelector('.soilife-sticky-atc__btn').addEventListener('click', function () {
      buyButton.click();
    });

    // Reveal once the real buy button leaves the viewport (CSS keeps it
    // desktop-hidden regardless).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) bar.classList.remove('is-visible');
          else bar.classList.add('is-visible');
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(buyButton);
    } else {
      bar.classList.add('is-visible');
    }
  }

  function init() {
    buildIndividualPrices();
    convertToDropdowns();
    preSelectDefaults();
    rearrangeLayout();

    // Selector variants are embedded in the picker JSON (built into
    // variantByOptions by buildIndividualPrices), so no individual-product
    // fetch is needed — the buy box adds the single matching combination variant.
    fetchIndividualProducts();
    initPricing();
    overrideBuyButton();
    injectStickyAtc();
    // Self-contained Description/Ingredients/Application dropdowns under the buy
    // box (after the guarantee line that overrideBuyButton just created).
    injectProductAccordions();

    injectDiscountMessaging();
    injectSocialProofBar();
    reorderSections();
    // injectAlsoBought();
    replaceTwoPartSection();
    /* FAQ now handled by soilife-faq-shared.js */
    fixProductGridSection();
  }

  // ── Robust readiness ────────────────────────────────────────────────
  // Foxify renders the picker asynchronously. A fixed 500ms timer was
  // unreliable on slow mobile/networks: if the picker wasn't ready, the
  // dropdowns + buy-button override never attached and Add-to-Cart silently
  // did nothing. Instead, wait until the picker, its option fields AND the
  // buy button all exist, then init once. Observer catches it ASAP; the poll
  // is a fallback; both are capped so they can't run forever.
  var _inited = false;
  function _ready() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return false;
    if (!picker.querySelector('.x-variant-picker__input')) return false;
    if (!document.querySelector(BUY_BUTTON_SELECTOR)) return false;
    return true;
  }
  function _boot() {
    if (_inited) return;
    if (!_ready()) return;
    _inited = true;
    try { init(); }
    catch (e) { if (window.console) console.error('[soilife-atc] init failed', e); }
  }
  function startWaiting() {
    _boot();
    if (_inited) return;
    var tries = 0;
    var poll = setInterval(function() {
      tries++;
      _boot();
      if (_inited || tries > 150) clearInterval(poll); // ~15s @ 100ms
    }, 100);
    var obs = new MutationObserver(function() {
      _boot();
      if (_inited) { obs.disconnect(); clearInterval(poll); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 16000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWaiting);
  } else {
    startWaiting();
  }
})();
